
export class ProgramApplicationsInvestorNav {
  public static item = {
    title: 'program.tab.applications',
    url: 'applications-list',
    icon: '<img src="./assets/icons/line-icons/nav/grey/application.svg" width="23px" height="23px">',
    testId: 'prog-nav-applications-investor'
  };
}
